const posts = [
  {
    _id: "63cae259ccea636a4d97d0bc",
    userId: "63cae259ccea636a4d97d0b5",
    firstName: "Lila",
    lastName: "Fernandez",
    location: "Montreal, QC",
    description:
      "Just got back from an incredible hike in the mountains! The views were absolutely breathtaking and the fresh air was so invigorating. There's nothing quite like connecting with nature and challenging yourself physically to feel alive. Can't wait for the next adventure! 🏔️🌲 #MountainHiking #NatureLovers #AdventureTime",
    picturePath: "post8.webp",
    userPicturePath: "p3.webp",
    likes: {
      "63cae259ccea636a4d97d0b4": true,
      "63cae259ccea636a4d97d0b6": true,
      "63cae259ccea636a4d97d0b7": true,
      "63cae259ccea636a4d97d0b8": true,
    },
    comments: [
      "Wow, what a breathtaking view! 🏞️",
      "Wow, your post about your mountain hike is breathtaking! It's so important to disconnect from the hustle and bustle of daily life and spend time in nature. Your photos are absolutely stunning and truly capture the beauty of the mountains. Thank you for sharing your experience and inspiring me to get out and explore more! 🥾",
      "The beauty of nature is truly awe-inspiring. 😍",
      "Looks like a great way to get some exercise and fresh air! 🌬️",
      "Your post about your mountain hike is so inspiring! It's amazing to see how nature has the power to soothe the soul and bring a sense of peace and tranquility. I'm so glad you were able to experience the beauty of the mountains and I hope to have my own mountain adventure soon. Thank you for sharing! 🌄",
      "Can't wait to hit the trails on my next mountain adventure! 🏔️",
    ],
    __v: 0,
    createdAt: "2023-01-20T18:50:04.394Z",
    updatedAt: "2023-02-15T01:28:54.508Z",
  },
  {
    _id: "63cae259ccea636a4d97d0bf",
    userId: "63cae259ccea636a4d97d0b9",
    firstName: "Tessa",
    lastName: "Gray",
    location: "Los Angeles, CA",
    description:
      "Food is not just fuel for our bodies, it's also a source of joy, comfort, and connection. Whether it's a home-cooked meal with loved ones or a delicious treat from our favorite bakery, there's something special about the way food brings people together and nourishes our souls. 🍴❤️\n",
    picturePath: "post1.webp",
    userPicturePath: "p7.webp",
    likes: {
      "63cae259ccea636a4d97d0b5": true,
      "63cae259ccea636a4d97d0ba": true,
      "63cae259ccea636a4d97d0b7": true,
      "63d3245310249c43ca38804a": true,
    },
    comments: [
      "Absolutely agree with you! Food is so much more than just a source of nutrition. It has the power to create memories and bring people together in such a beautiful way. Love your message! ❤️",
      "Your words couldn't be more true. I have some of my fondest memories with friends and family while sharing a meal. It's amazing how food can foster connection and bring so much joy. 🙌🏻",
      "This is such a beautiful reminder to appreciate the role that food plays in our lives beyond just fueling our bodies. It's amazing how something as simple as a home-cooked meal or a dessert can bring so much comfort and happiness. Love this post! 😍",
    ],
    __v: 0,
    createdAt: "2023-01-20T18:50:04.395Z",
    updatedAt: "2023-02-15T03:15:52.114Z",
  },
  {
    _id: "63cae259ccea636a4d97d0c0",
    userId: "63cae259ccea636a4d97d0ba",
    firstName: "Xavier",
    lastName: "Woods",
    location: "Hamilton, ON",
    description:
      "Last night's concert was one for the books! 🎶 The energy was electric, the music was amazing, and the crowd was on fire! 🤘 I had such an incredible time singing, dancing, and just letting loose with some of my closest friends. There's nothing quite like the feeling of being in a room full of people who share your love for music. 🎤 Can't wait for the next one! #ConcertVibes #LiveMusic #GoodTimes #RockOn 🤘🎸",
    picturePath: "post3.webp",
    userPicturePath: "p8.webp",
    likes: {
      "63cae259ccea636a4d97d0b5": true,
      "63cae259ccea636a4d97d0b7": true,
      "63cae259ccea636a4d97d0b9": true,
      "63cae259ccea636a4d97d0bb": true,
      "63d3245310249c43ca38804a": true,
    },
    comments: [
      "This sounds like it was an unforgettable experience! I can feel the energy and excitement from your words. It's amazing how music can bring people together in such a powerful way. So happy you had a great time! 🎶🤘",
      "You captured the essence of what makes live music so special. There's nothing like being surrounded by people who share your love for music and feeling the energy of the crowd. Glad you had an amazing time, can't wait for the next one! 🤩🎤",
      "Sounds like you had an epic night! There's something about live music that just gets your heart pumping and your feet moving. So glad you got to experience that magic with your friends. 🙌🏻🎸",
      "Your post makes me feel like I was there! I can just imagine the adrenaline rush and excitement from the concert. So happy you had an incredible time and got to share it with friends. 🎶🤘",
      "Your post brought a smile to my face! There's no feeling quite like being surrounded by like-minded people who share your love for music. So glad you had a blast at the concert and made some great memories with your friends. 🎤🤩",
    ],
    __v: 0,
    createdAt: "2023-01-20T18:50:04.395Z",
    updatedAt: "2023-04-05T01:54:49.857Z",
  },
  {
    _id: "63cae259ccea636a4d97d0bd",
    userId: "63cae259ccea636a4d97d0b7",
    firstName: "Avery",
    lastName: "Johnson",
    location: "Calgary, AB",
    description:
      "Salads are a great way to nourish our bodies with vitamins and nutrients while keeping us feeling full and energized. Today's salad was a colorful medley of different textures and flavors that satisfied both my taste buds and my hunger. I love how you can get creative with the ingredients and create a unique salad every time! What are your favorite salad toppings? #HealthyEating #SaladInspo #FuelYourBody 🥗🌿🥕🍅\n",
    picturePath: "post4.webp",
    userPicturePath: "p6.webp",
    likes: {
      "63cae259ccea636a4d97d0bb": true,
      "63cae259ccea636a4d97d0b8": true,
      "63cae259ccea636a4d97d0b5": true,
      "63cae259ccea636a4d97d0b6": true,
      "63d3245310249c43ca38804a": true,
    },
    comments: [
      "Your salad sounds amazing! I love how salads can be so versatile and customizable. My favorite toppings are avocado, feta cheese, and sunflower seeds. 😍🥑🧀",
      "I couldn't agree more! Salads are such a great way to get in your daily dose of nutrients and keep you feeling full and energized. I'm a big fan of adding roasted chickpeas, quinoa, and a sprinkle of nutritional yeast to my salads. 🙌🏻🍲",
      "Your post is making me crave a delicious salad! I love experimenting with different flavors and textures, from roasted veggies to crunchy nuts and seeds. My go-to toppings are definitely grilled chicken, cherry tomatoes, and a drizzle of balsamic glaze. 🤤🍗🍅",
      "Your salad looks absolutely beautiful and so vibrant! I agree that the possibilities are endless when it comes to creating a delicious and healthy salad. I'm all about adding some fresh fruit, like berries or sliced apples, to my salads for an extra burst of flavor. 🍎🍓🥗",
    ],
    __v: 0,
    createdAt: "2023-01-20T18:50:04.394Z",
    updatedAt: "2023-02-15T03:15:46.700Z",
  },
  {
    _id: "63cae259ccea636a4d97d0be",
    userId: "63cae259ccea636a4d97d0b8",
    firstName: "Cameron",
    lastName: "Bailey",
    location: "Edmonton, AB",
    description:
      "Feeling so grateful for this beautiful day and the people in my life who make it even better. ☀️💕 Whether it's a simple conversation with a friend or a walk in nature, it's the small things that truly bring joy to our lives. Remember to appreciate the little moments and hold on to the ones that make your heart feel full. #Gratitude #Blessed #LifeIsGood 🙏💖",
    picturePath: "post2.webp",
    userPicturePath: "p5.webp",
    likes: {
      "63cae259ccea636a4d97d0b5": true,
      "63cae259ccea636a4d97d0ba": true,
      "63cae259ccea636a4d97d0b7": true,
      "63cae259ccea636a4d97d0b9": true,
    },
    comments: [
      "This post truly speaks to my heart. It's so important to appreciate the small things in life and the people who bring us joy and happiness. Thank you for the beautiful reminder to focus on gratitude and appreciate the present moment. 🙌💛",
      "I love this message! It's so easy to get caught up in our busy lives and forget to appreciate the little moments that make life so special. I'm grateful for my family, friends, and the beautiful nature around us that bring me so much joy every day. ☺️🌳💕",
      "You're absolutely right! Gratitude is such a powerful force that can bring so much positivity and happiness into our lives. I'm grateful for the simple things, like a warm cup of coffee in the morning or a good book to read before bed. It's the small moments that add up to a beautiful life. 🌟📚☕",
      "I couldn't agree more! It's so easy to take the people and things in our lives for granted, but practicing gratitude and focusing on the positive can truly transform our lives. I'm grateful for the love and support of my family and friends, and the beautiful sunsets that remind me to appreciate the beauty in the world. 🌅🙏❤️",
      "Your post is so inspiring and uplifting. It's a beautiful reminder to focus on the good in our lives and cherish the people who make it all worthwhile. I'm grateful for the small moments that bring me joy, like a good laugh with friends or a beautiful flower blooming in the garden. Life truly is a beautiful gift. 🌺💖",
    ],
    __v: 0,
    createdAt: "2023-01-20T18:50:04.395Z",
    updatedAt: "2023-04-05T01:54:44.672Z",
  },
  {
    _id: "63cae259ccea636a4d97d0c1",
    userId: "63cae259ccea636a4d97d0bb",
    firstName: "Jessica",
    lastName: "Dunn",
    location: "Washington, DC",
    description:
      "Nothing beats the feeling of fresh air in your lungs and the crunch of leaves beneath your feet. Spent the day hiking through the forest and taking in all the beauty of nature. What an incredible reminder of the power and majesty of our world. 🍂🌲 #NatureLover #HikingAdventures #GetOutside",
    picturePath: "post6.webp",
    userPicturePath: "p9.webp",
    likes: {
      "63cae259ccea636a4d97d0b5": true,
      "63cae259ccea636a4d97d0b6": true,
    },
    comments: [
      "Sounds like an amazing hike with breathtaking views! 🌲🏞️",
      "There's nothing like spending time in nature to clear your mind and recharge. 🌿✨",
      "Love that feeling of accomplishment after a long hike! 🙌💪",
      "Your post makes me want to go on a hike and explore the great outdoors! 🚶\u200d♀️🌅",
      "So glad you had a great time on your hike! The natural beauty around us is truly awe-inspiring. 🌻🌳",
    ],
    __v: 0,
    createdAt: "2023-01-20T18:50:04.395Z",
    updatedAt: "2023-01-30T21:54:10.536Z",
  },
  {
    _id: "63dbeaf6af00a49d7f574348",
    userId: "63d3245310249c43ca38804a",
    firstName: "John",
    lastName: "Smith",
    location: "Toronto, ON",
    description:
      "Taking time to slow down and recharge is so important for our mental and physical health. Today, I spent the afternoon reading a book and sipping on some tea, and it was exactly what I needed. 📚☕️ It's easy to get caught up in the hustle and bustle of life, but remember to take breaks and give yourself permission to just be. You deserve it. #SelfCare #TakeABreak #RelaxationTime 🧘\u200d♀️✨",
    userPicturePath: "p11.webp",
    likes: {
      "63cae259ccea636a4d97d0b5": true,
      "63cae259ccea636a4d97d0b9": true,
      "63cae259ccea636a4d97d0ba": true,
    },
    comments: [
      "Sounds like the perfect way to unwind and recharge! Taking time to care for yourself is key to living a healthy and fulfilling life. 🙌",
      "Self-care is so important and it's great to see you making time for it! Enjoying the simple pleasures in life like a good book and a warm cup of tea can do wonders for the soul. ☕️📖",
      "This is a wonderful reminder to slow down and appreciate the present moment. Taking a break and indulging in a little self-care can be so rejuvenating and help us come back stronger and more focused. Keep it up! 🌟",
    ],
    createdAt: "2023-02-02T16:55:18.887Z",
    updatedAt: "2023-02-15T03:31:46.331Z",
    __v: 0,
  },
  {
    _id: "63eaf799db89d2a2694b9052",
    userId: "63d3245310249c43ca38804a",
    firstName: "John",
    lastName: "Smith",
    location: "Toronto, ON",
    description:
      "Happiness is not a destination, it's a journey. Today, I choose to focus on the things that bring me joy and bring positivity into my life. Whether it's a good cup of coffee, a walk in nature, or spending time with loved ones, I'm grateful for the little things that make life so sweet. 💛 What brings you joy today? #Grateful #ChooseHappiness #GoodVibesOnly 🌻",
    userPicturePath: "p11.webp",
    likes: {
      "63cae259ccea636a4d97d0ba": true,
    },
    comments: [],
    createdAt: "2023-02-14T02:53:13.139Z",
    updatedAt: "2023-02-14T02:53:13.139Z",
    __v: 0,
    picturePath: "post7.webp",
  },
  {
    _id: "63ec4d1067437660ecd114b3",
    userId: "63cae259ccea636a4d97d0ba",
    firstName: "Xavier",
    lastName: "Woods",
    location: "Hamilton, ON",
    description:
      "Friends are the family we choose for ourselves. 💖 Whether we've known them for years or just met, our friends bring us love, laughter, and support when we need it most. Here's to the ones who make life a little brighter every day! #Friendship #Blessed #GoodVibes",
    userPicturePath: "p8.webp",
    likes: {
      "63cae259ccea636a4d97d0b9": true,
      "63cae259ccea636a4d97d0b5": true,
    },
    comments: [
      "Couldn't agree more! Friends are the glue that holds us together and make life so much sweeter. ❤️",
      "Amen to that! Feeling so blessed to have a circle of friends who support, uplift, and inspire me. 🙌🏼 #FriendshipStrong",
    ],
    createdAt: "2023-02-14T02:53:13.139Z",
    updatedAt: "2023-02-14T02:53:13.139Z",
    __v: 0,
  },
];

export const setClientPosts = (updatedPost) => {
  const result = posts.map((x) => {
    const post = posts.find((post) => x._id === post._id);
    return post ? post : x;
  });
  console.log(result);
};

export default posts;
